import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

const ErrorDisplay = ({ error, t }) => {
  let responseStr = t('error:errGenericText');
  if (error.response) {
    if (error.response.status === 404) {
      responseStr = t('error:err404Text');
    } else if (error.response.status === 500) {
      responseStr = t('error:err500Text');
    } else if (error.response.status === 401) {
      responseStr = t('error:err401Text');
    } else if (error.response.status === 403) {
      if (error.response.data && error.response.data.message !== '') {
        responseStr = error.response.data.message;
      } else {
        responseStr = t('error:err403Text');
      }
    } else if (error.response.data && error.response.data.message !== '') {
      responseStr = error.response.data.message;
    }
  }
  return (
    <div className='fe-message-container'>
      <div className='container'>
        <div className='row'>
          <div className='col'>
            <h1 className='fe-heading'>{t('error:errDisplayTitle')}...</h1>
            <p>{responseStr}</p>
            <a className='fe-link' href='/getaways'>
              {t('gen:goHome')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

ErrorDisplay.propTypes = {
  error: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(ErrorDisplay);
